import { Menu, MenuItem } from "@mui/material"

export const RightClickMenu = (props: any) => {
    return (
        <Menu   
              
            open={Boolean(props.point)}
            onClose={() => props.onClose()}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            anchorEl={null}
            anchorReference="anchorPosition"
            anchorPosition={props.point}>
            <MenuItem onClick={() => {
                props.onRename?.();
                props.onClose?.();
            }} dense>Rename</MenuItem>
            <MenuItem onClick={() => {
                props.onCreateSubview?.();
                props.onClose?.();
            }} dense>Create subview</MenuItem>
        </Menu>
    )
}